/* eslint-disable react/destructuring-assignment */
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import RouteRow from "../RouteRow";
import ReportError from "../ReportError";
import RouteDepartureSeparator from "../RouteDepartureSeparator";
import styles from "./Route.scss";
import memoize from "memoize-one";
import {mergeLeftPanelRouteSegmentsForKeyPoints} from "../../utils/metricsCalculator";
import Checkbox from "ati-ui-react/components/Checkbox";
import {withNamespaces} from "react-i18next";
import LegendPopup from "../LegendPopup";
import Link from "ati-ui-react/components/Link";
import Portal from "../Portal";

class Route extends React.Component {
  constructor(props) {
    super(props);
  }

  handleExcludeCity = city => {
    this.props.excludeCity(city);
  };

  handleCheckboxChange = checked => {
    this.props.toggleShowPassingCitiesInRouteDetails(checked);
  };
  
  renderRoutes = (routeSegments, keyPointCountryIds) => {

    return routeSegments.map((routeSegment, index) => {
      return (
        <RouteRow
          key={index}
          routeSegment={routeSegment}
          nextRouteSegment={routeSegments[index + 1]}
          handleExcludeCity={this.handleExcludeCity}
          keyPointCountryIds={keyPointCountryIds}
        />
      );
    });
  }

  render() {
    const {
      className,
      routeSegments,
      /** @type {RouteRequest} */
      routeRequest,
      showPassingCitiesInRouteDetails,
      openLegendPopup,
      showLegendPopup,
      closeLegendPopup,
      t
    } = this.props;
    
    const departureCountry = routeSegments.length > 0 && routeSegments[0].country ? routeSegments[0].country.name : undefined;
    const getRouteSegments = memoize((showPassingCitiesInRouteDetails, routeSegments) =>
        showPassingCitiesInRouteDetails ? routeSegments : mergeLeftPanelRouteSegmentsForKeyPoints(routeSegments));
    const keyPointCountryIds = [routeRequest.from.getCountryId(), ...routeRequest.through.map(item => item.getCountryId()), routeRequest.to.getCountryId()].filter(Boolean);

    return (
        <React.Fragment>
          <div className={classnames(styles.routeParamsContainer, className)}>
            <div className={styles.routeTitle}>{t("trace-route-title", "Подробный маршрут")}</div>
            <div className={styles.legend}>
              <Link // eslint-disable-line
                  small
                  gray
                  type="pseudo" 
                  onClick={openLegendPopup}
                  classNameContainer={styles.legendLink}
              >
                {t("trace-filters-show-legend-button-text", "Легенда")}
              </Link>
              {showLegendPopup && (
                  <Portal id="legend-popup-container">
                    <hr/>
                    <LegendPopup
                        closePopup={closeLegendPopup}
                    />
                    <hr/>
                  </Portal>
              )}
            </div>
            <div className={styles.routeCheckboxContainer}>
              <Checkbox
                  name="showPassingCitiesInRouteDetails"
                  checked={showPassingCitiesInRouteDetails}
                  onChange={e => this.handleCheckboxChange(e.target.checked)}
                  label={t("trace-route-show-passing-cities-label")}
                  size="small"
              />
            </div>
          </div>
          <div className={classnames(styles.container, className)}>
            <RouteDepartureSeparator country={departureCountry}/>
            {
              this.renderRoutes(getRouteSegments(showPassingCitiesInRouteDetails, routeSegments), keyPointCountryIds)
            }
            <ReportError/>
          </div>
        </React.Fragment>
    );
  }
}

Route.defaultProps = {
  className: "",
};

Route.propTypes = {
  className: PropTypes.string,
  excludeCity: PropTypes.func.isRequired,
  showLegendPopup: PropTypes.bool.isRequired,
  openLegendPopup: PropTypes.func.isRequired,
  closeLegendPopup: PropTypes.func.isRequired
};

export default withNamespaces()(Route);